<template>
  <w-icon-wrapper
    :height="20"
    :width="24"
    icon-name='work-pdf-icon'
    view-box="0 0 20 24"
  >
    <path
      id="Pfad_55802"
      data-name="Pfad 55802"
      d="M14,2.829,17.172,6H14ZM2,2H12V8h6V22H2ZM0,0V24H20V6L14,0Z"
      fill="currentColor"
    />
    <g
      id="Gruppe_25451"
      data-name="Gruppe 25451"
    >
      <g
        id="Gruppe_25450"
        data-name="Gruppe 25450"
      >
        <path
          id="Pfad_55803"
          data-name="Pfad 55803"
          d="M7.5,13.41c0,.958-.719,1.555-1.868,1.555H4.768v1.186h-1v-4.3H5.635c1.149,0,1.868.6,1.868,1.561m-1.008,0c0-.473-.307-.75-.916-.75H4.768v1.494h.811c.609,0,.916-.277.916-.744"
          fill="currentColor"
        />
        <path
          id="Pfad_55804"
          data-name="Pfad 55804"
          d="M8.211,11.849h1.955a2.161,2.161,0,1,1,0,4.3H8.211Zm1.906,3.485a1.336,1.336,0,1,0,0-2.667h-.91v2.667Z"
          fill="currentColor"
        />
        <path
          id="Pfad_55805"
          data-name="Pfad 55805"
          d="M14.286,12.648v1.137h1.991v.8H14.286v1.567h-1v-4.3h3.251v.8Z"
          fill="currentColor"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconPdf' };
</script>